import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Axios from "axios";
import { GetJobRoles } from "../apiconstants/constants";
import { useCountry } from "../contexts/countrycodecontext.js";
import ConsultantLayout from "../commonlayouts/consultantlayout.js";
import Swal from "sweetalert2";

const LinkedInContacts = () => {
  const [linkedinUrls, setLinkedinUrls] = useState("");
  const [jobRoles, setJobRoles] = useState([]);
  const [selectedJobRoleId, setSelectedJobRoleId] = useState("");
  const navigate = useNavigate();
  const { selectedCountry } = useCountry();

  let Guid = "";
  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid");
  const email = localStorage.getItem("email");
  const roleID = localStorage.getItem("roleID");

  if (roleID == 3) {
    Guid = employerGuid;
  } else {
    Guid = guid;
  }

  useEffect(() => {
    if (selectedCountry) {
      fetchJobRoles();
    }
  }, [selectedCountry]);

  const fetchJobRoles = () => {
    const getApiUrl = `${GetJobRoles.APIURL}?UserGuid=${Guid}&CountryID=${selectedCountry}`;
    Axios.get(getApiUrl)
      .then((response) => {
        setJobRoles(response.data);
      })
      .catch((error) => {
        console.error("Error fetching job roles:", error);
      });
  };

const handleSubmit = () => {
  const rawInput = linkedinUrls.trim();
  const urlsArray = rawInput
    .split("https")
    .map((part) => part.trim())
    .filter((part) => part.length > 0)
    .map((part) => `https${part}`);

  if (!selectedJobRoleId) {
                     Swal.fire({
                        position: 'center',
                        icon: 'warning',
                        title: 'Please select a job role.',
                        showConfirmButton: false,
                        timer: 5000,
                    });
    return;
  }

  if (urlsArray.length === 0) {
       Swal.fire({
                        position: 'center',
                        icon: 'warning',
                        title: 'Please enter at least one LinkedIn URL.',
                        showConfirmButton: false,
                        timer: 5000,
                    });
    return;
  }

  // Store in localStorage (optional fallback)
  localStorage.setItem("jobRoleId", selectedJobRoleId);
  localStorage.setItem("linkedinUrls", JSON.stringify(urlsArray));

  // ✅ Pass as state
  navigate("/Employer/ViewMatchedLinkedinContacts", {
    state: {
      linkedinUrls: urlsArray,
      jobRoleId: selectedJobRoleId
    }
  });
};


  return (
    <ConsultantLayout>
         <div className="mt-4">
        
                        <div className="responsive-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <h2 style={{ color: "#00a7ac" }}>LinkedIn Contacts</h2>
        
                       
                        </div>
                        <hr/>
                        </div>
      <div className="mb-3">
        <label>LinkedIn URLs:</label>
        <textarea
          className="form-control"
        style={{ height: 250 }}

          value={linkedinUrls}
          onChange={(e) => setLinkedinUrls(e.target.value)}
          placeholder="Paste all LinkedIn URLs here Ex: https://linkedin.com/in/abc, https://..."
        />
      </div>

      <div className="mb-3">
        <label>Select Job Role:</label>
        <select
          className="form-control mt-2"
          style={{ height: 50, borderRadius: 15, fontSize: 12 }}
          value={selectedJobRoleId}
          onChange={(e) => setSelectedJobRoleId(e.target.value)}
        >
          <option value="">Select Job Role</option>
          {jobRoles.map((item, index) => (
            <option key={index} value={item.jobRoleId}>
              {item.jobRole}
            </option>
          ))}
        </select>
      </div>
      
                                                         
                                          <button id="svbutton" style={{ float: "right" }} onClick={handleSubmit} className="btn btn-primary pf-save mb-3 mr-3">
                                           
                                              Submit
                                          </button> &nbsp;&nbsp;&nbsp;

    </ConsultantLayout>
  );
};

export default LinkedInContacts;
